import { CreateOrderRequestBody } from '@paypal/paypal-js/types/apis/orders';
import React, { useEffect, ReactElement } from 'react';
import { createUseStyles } from 'react-jss';
import { useHistory } from 'react-router-dom';
import Store from 'mockStores/components/stores/Store';
import { MockStoresWindow } from 'mockStores/types';

declare let window: MockStoresWindow;

function appendScript(src, onload) {
  const script = document.createElement('script');
  script.defer = true;
  script.src = src;
  if (onload) {
    script.onload = onload;
  }
  document.head.appendChild(script);
}

const useStyles = createUseStyles({
  paypalButton: {
    paddingTop: '8px',
  },
});

type SPBv5Props = {
  paypalScript: string;
  noShipping?: boolean;
};

function SPBv5({ paypalScript, noShipping } : SPBv5Props): ReactElement {
  const classes = useStyles();

  const history = useHistory();

  function renderPayPalButton(fundingSource, id) {
    window.paypal
      .Buttons({
        createOrder(data, actions) {
          const createOrderParams: CreateOrderRequestBody = { purchase_units: [{ amount: { value: '0.01' } }] };
          if (noShipping) {
            createOrderParams.application_context = { shipping_preference: 'NO_SHIPPING' };
          }

          console.log('MERCHANT CREATE ORDER', { actions, createOrderParams, data }); // eslint-disable-line no-console
          return actions.order.create(createOrderParams);
        },
        fundingSource,
        async onApprove(data, actions) {
          console.log('MERCHANT APPROVE ORDER', data, actions); // eslint-disable-line no-console
          history.push('/continue');
        },
        onCancel() {
          console.log('MERCHANT CANCEL ORDER'); // eslint-disable-line no-console
        },
        onError(err) {
          console.log('MERCHANT ERROR ORDER', err); // eslint-disable-line no-console
        },
      })
      .render(id);
  }

  useEffect(() => {
    appendScript(paypalScript, () => {
      renderPayPalButton(window.paypal.FUNDING.PAYPAL, '#paypal-button-container');
      // renderPayPalButton(window.paypal.FUNDING.PAYLATER, '#paylater-button-container');
    });
  }, []);

  const renderButton = () => (
    <div>
      <div id="paypal-button-container" className={ classes.paypalButton } />
      <div id="paylater-button-container" className={ classes.paypalButton } />
    </div>
  );

  return (
    <Store
      button={ renderButton() }
      title="Honey Checkout Mock Store (SPBv5)"
    />
  );
}

export default SPBv5;
